import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _registerUrl = `${environment.api}/auth/register`;
  private _loginUrl = `${environment.api}/login/sign`;
  private _testUrl = `${environment.api}/login/test`;
  private _checkResetPasswordTokenUrl = `${environment.api}/auth/check_reset_password_token`;
  private _requestResetPasswordUrl = `${environment.api}/auth/request_reset_password`;
  private _updatepasswordUrl = `${environment.api}/auth/update_password`;
 
  isLoggedIn = false;
  constructor(private http: HttpClient) { }
  
  isAdminRights(){
    return true;
  }

  registerUser(user)
  {
    return this.http.post<any>(this._registerUrl,user);
  }

  loginUser(user)
  {
    return this.http.post<any>(this._loginUrl,user);
  }

  check_reset_password_token(data)
  {
    return this.http.post<any>(this._checkResetPasswordTokenUrl,data);
  }

  request_reset_password(data)
  {
    return this.http.post<any>(this._requestResetPasswordUrl,data);
  }
  update_password(data){
    return this.http.post<any>(this._updatepasswordUrl,data);
  }

  loggedIn()
  {
    return !!localStorage.getItem("currentUser");
  }

  getToken()
  {
    return localStorage.getItem("token");
  }

  logout(data) { 
    //console.log(data); return false;
    //this.http.post<any>(this._testUrl,data); //return false;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('APIKEY');
    localStorage.removeItem('id');
    localStorage.removeItem('role_id');
    localStorage.removeItem('role_name');
    localStorage.removeItem('token');
    localStorage.removeItem('image64data');
    localStorage.removeItem('company_id');
    localStorage.removeItem('loginType');
    localStorage.removeItem('adminId');
    this.isLoggedIn = false;
  }


}
